/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import { type CustomerAccountInfo, retrieveCustomerInfo } from './service/retrieveCustomerInfo'
import { getAuth } from '@/auth/authRef'
import { AuthStatus } from '@/auth/auth'

let customer: Promise<CustomerAccountInfo> | null = null

/**
 * Resolves to the customer account information.
 * Will throw if not logged in.
 */
export function getCustomer(): Promise<CustomerAccountInfo> {
    if (!customer) {
        customer = retrieveCustomerInfo()
        const sub = getAuth().status.onData((value) => {
            if (value === AuthStatus.SIGNED_OUT) {
                customer = null
                sub()
            }
        })
    }
    return customer
}
